module.exports = __webpack_public_path__ + "static/media/freshsuccess-logo.cd9eb63f.svg";